import { atom } from 'jotai';
import { Group } from '../pages/groupOverview/GroupOverview';

export const groupAtom = atom<Group[]>([]);
